import { render, staticRenderFns } from "./BacEditableImage.vue?vue&type=template&id=a8a059a8&scoped=true&"
import script from "./BacEditableImage.vue?vue&type=script&lang=ts&"
export * from "./BacEditableImage.vue?vue&type=script&lang=ts&"
import style0 from "./BacEditableImage.vue?vue&type=style&index=0&id=a8a059a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a059a8",
  null
  
)

export default component.exports